import { render, staticRenderFns } from "./SubCategorySlider.vue?vue&type=template&id=f42428b4&scoped=true"
import script from "./SubCategorySlider.vue?vue&type=script&lang=js"
export * from "./SubCategorySlider.vue?vue&type=script&lang=js"
import style0 from "./SubCategorySlider.vue?vue&type=style&index=0&id=f42428b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42428b4",
  null
  
)

export default component.exports